import React, { useCallback, useState } from 'react';
import { capitalize } from 'lodash';
import classNames from 'classnames';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { getOrgTermsContent } from '../../../../../content/utils.js';
import SubHeader from '../../../../SubHeader.jsx';
import CustomTooltip from '../../../../CustomTooltip.jsx';
import QuestionBlueIcon from '../../../../icons/QuestionBlueIcon.jsx';
import { isAuthorized } from '../../../../AuthorizedAction.js';
import styles from './CompanySettingsAccordion.module.css';

const CompanySettingsAccordion = ({
  type,
  onEdit,
  tooltipContent,
  permissions,
}) => {
  const [surveyTemplatesHidden, setSurveyTemplatesHidden] = useState(true);

  const toggleSurveyTemplates = useCallback((e) => {
    e.preventDefault();
    setSurveyTemplatesHidden((hidden) => !hidden);
  }, []);

  const tableContainerId = `${type}InitiativesTableContainer`;
  const typeCapitalized = capitalize(type);

  const className = classNames(styles.surveyTemplatesSection, {
    [styles.surveyTemplatesHidden]: surveyTemplatesHidden,
  });

  const checkAuthorize = isAuthorized('update', 'surveyTemplate', permissions);

  return (
    <section className={className} onClick={checkAuthorize ? onEdit : null}>
      <SubHeader flexJustify small accordion>
        <div className={styles.categoriesHeading}>
          <div className="flex row">
            <h2>
              <a
                aria-controls={tableContainerId}
                aria-expanded={!surveyTemplatesHidden}
                className="flex"
                href="components/organizations/Settings/ChangeInsightTemplates/ChangeInsightTemplatesAccordion#"
                onClick={toggleSurveyTemplates}
                role="button"
              >
                <span className={styles.initiativeType}>{typeCapitalized}</span>
              </a>
            </h2>
            {tooltipContent ? (
              <CustomTooltip
                tooltip={
                  <div>
                    <strong>
                      <h5
                        style={{
                          fontSize: '14px',
                          fontWeight: '600',
                          lineHeight: '20px',
                          color: '#153142',
                        }}
                        className="m-b-8"
                      >
                        {getOrgTermsContent('projectStatuses')}
                      </h5>
                    </strong>
                    <p
                      style={{
                        fontSize: '12px',
                        fontWeight: '400',
                        lineHeight: '20px',
                        color: '#7F8FA4',
                      }}
                      className="m-b-0 text-muted"
                    >
                      {tooltipContent}
                    </p>
                  </div>
                }
                id="tooltip"
              >
                <Button
                  aria-label="View Support for Change modal"
                  type="button"
                  className="flex flex-align-center m-l-8 btn-last-update-icon"
                >
                  <QuestionBlueIcon />
                </Button>
              </CustomTooltip>
            ) : null}
          </div>
          <div>
            {isAuthorized('update', 'surveyTemplate', permissions) ? (
              <Button bsStyle="default" className="btn-edit" onClick={onEdit}>
                Edit
              </Button>
            ) : null}
          </div>
        </div>
      </SubHeader>
    </section>
  );
};

CompanySettingsAccordion.propTypes = {
  type: PropTypes.string.isRequired,
};
export default CompanySettingsAccordion;
